import { render, staticRenderFns } from "./hobbies-bubble4.vue?vue&type=template&id=4d5e2380&"
import script from "./hobbies-bubble4.vue?vue&type=script&lang=js&"
export * from "./hobbies-bubble4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports